var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile() && !_vm.hideFooter)?_c('div',{staticClass:"mobile-footer-copyright"},[_vm._v(" AIRspirit © "+_vm._s(_vm.currentYear)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }